<template>
  <v-dialog
    persistent
    :value="opened"
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="close()"
    @keydown.enter="close()"
  >
    <v-card block flat>
      <v-card-title class="warning-title">
        <v-icon class="warning--text mr-1">warning</v-icon>
        {{ warningTitle }}
      </v-card-title>

      <v-card-text class="text-xs-left warning-text">
        {{ warningText }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          v-if="allowSkip"
          flat
          outline
          class="grey text-none font-weight-bold"
          @click="skip()"
        >
          Skip
        </v-btn>

        <v-btn class="primary text-none font-weight-bold" flat @click="close()">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },

    warningTitle: {
      type: String,
      required: true,
    },

    warningText: {
      type: String,
      required: true,
    },

    allowSkip: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },

    skip() {
      this.$emit('skip');
    },
  },
};
</script>

<style lang="postcss" scoped>
.warning-title {
  font-size: 22px;
  font-weight: bold;
  padding-bottom: 0;
}

.warning-text {
  font-size: 16px;
}
</style>
